import * as React from 'react'
import * as css from './ImageAndTextSectionsCentered.module.css'
import SanityBlock from 'components/common/SanityBlock'
import CTALink from 'components/common/CTALink'
import Img from './Img'
import clsx from 'clsx'

const ImageAndTextSectionsCentered = ({ pretitle, title, description, sections, _key }) => (
	<section className="bg-suede-black p-4 md:py-20" id={`section-${_key}`}>
		{(!!title || !!description) && (
			<header className="grid gap-4 text-center ctnr-sm padding !pb-12">
				{pretitle && <p className="technical-lg">{pretitle}</p>}
				<h2 className="h0">{title}</h2>
				{!!description && <p>{description}</p>}
			</header>
		)}

		{sections?.map((section, key) => (
			<Section {...section} key={key} />
		))}
	</section>
)

export default ImageAndTextSectionsCentered

const Section = ({ title, subtitle, _rawBody, link, image }) => (
	<article className="relative flex flex-col gap-4 md:gap-5 items-center justify-center max-w-[1200px] mx-auto">
		<div
			className={clsx('grid gap-8 relative z-[1] md:text-center max-w-screen-lg m-auto text-white')}
		>
			<h3 className="technical-lg text-3xl text-white">{title}</h3>

			{subtitle && <p>{subtitle}</p>}
			<div className={css.content}>
				<SanityBlock body={_rawBody} />
			</div>
			<CTALink {...link} />
		</div>

		<figure className="self-stretch">
			<Img objectFit="cover" className="w-auto" {...image} />
		</figure>
	</article>
)
